'use strict';

const MIN_DURATION_MINUTES = 15;

function toMinutes(hhmm) {
  const parts = String(hhmm).split(':');
  const h = parseInt(parts[0], 10) || 0;
  const m = parseInt(parts[1], 10) || 0;
  return h * 60 + m;
}

function toHHMM(total) {
  let t = Math.round(total);
  if (t < 0) t = 0;
  if (t > 1439) t = 1439;
  const h = Math.floor(t / 60);
  const m = t % 60;
  return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
}

function endFromStart(startHHMM, durationMinutes) {
  return toHHMM(toMinutes(startHHMM) + durationMinutes);
}

function durationFromTimes(startHHMM, endHHMM) {
  return toMinutes(endHHMM) - toMinutes(startHHMM);
}

function clampEnd(startHHMM, endHHMM, minDuration = MIN_DURATION_MINUTES) {
  const start = toMinutes(startHHMM);
  let end = toMinutes(endHHMM);
  if (end <= start) end = start + minDuration;
  return toHHMM(end);
}

function durationLabel(minutes) {
  const m = Math.max(0, Math.round(minutes));
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h && rem) return `${h}h ${rem}m`;
  if (h) return `${h}h`;
  return `${rem}m`;
}

module.exports = {
  MIN_DURATION_MINUTES,
  toMinutes,
  toHHMM,
  endFromStart,
  durationFromTimes,
  clampEnd,
  durationLabel,
};
